import {makeThemeProps} from "@themes/default/props/utils";

export default (theme, props, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getProductCardProps(theme, props, site);
};
